/**
 * i18n phase: brand / branch menu catalog (opt-in franchise templates).
 * Tuples are [ko, en, vi, ru].
 */

function pick(obj, langIndex) {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  }
  return out;
}

const brandCatalog = {
  hubTitle: ['브랜드·지점', 'Brand & branches', 'Thương hiệu & chi nhánh', 'Бренд и филиалы'],
  hubDesc: [
    '가맹점이면 초대코드로 가입, 본사면 메뉴 카탈로그 공유',
    'Franchisee? Join with an invite code. HQ? Share a menu catalog with branches.',
    'Là chi nhánh? Tham gia bằng mã mời. Là trụ sở? Chia sẻ catalog menu cho chi nhánh.',
    'Франчайзи? Присоединитесь по коду. Головной офис? Поделитесь каталогом меню.',
  ],
  linkHint: [
    '브랜드에 메뉴를 한 번 등록하면 지점에서 골라 가져옵니다. 가격은 지점마다 직접 입력합니다.',
    'Register menu content once on the brand; branches pick items and set their own prices.',
    'Đăng ký nội dung menu một lần trên thương hiệu; chi nhánh chọn món và tự nhập giá.',
    'Один раз добавьте меню бренда; филиалы выбирают позиции и задают свою цену.',
  ],
  loading: ['불러오는 중…', 'Loading…', 'Đang tải…', 'Загрузка…'],
  createLabel: ['새 브랜드 만들기', 'Create a brand', 'Tạo thương hiệu', 'Создать бренд'],
  createPh: ['예: BBQ Chicken', 'e.g. BBQ Chicken', 'VD: BBQ Chicken', 'напр. BBQ Chicken'],
  createBtn: ['만들기', 'Create', 'Tạo', 'Создать'],
  pickExisting: ['내 브랜드에 연결', 'Link an existing brand', 'Liên kết thương hiệu có sẵn', 'Привязать существующий бренд'],
  linkedLabel: ['연결된 브랜드', 'Linked brand', 'Thương hiệu đã liên kết', 'Привязанный бренд'],
  manageCatalogTitle: ['브랜드 메뉴 카탈로그', 'Brand menu catalog', 'Catalog menu thương hiệu', 'Каталог меню бренда'],
  manageCatalogDesc: [
    '사진·이름·설명만 등록 (가격 없음)',
    'Name, photo, description only (no prices)',
    'Chỉ tên, ảnh, mô tả (không có giá)',
    'Только название, фото и описание (без цен)',
  ],
  unlinkBtn: ['지점 연결 해제', 'Unlink this branch', 'Hủy liên kết chi nhánh', 'Отвязать филиал'],
  createLinkedToast: ['브랜드를 만들고 연결했습니다', 'Brand created and linked', 'Đã tạo và liên kết thương hiệu', 'Бренд создан и привязан'],
  linkedToast: ['브랜드에 연결했습니다', 'Linked to brand', 'Đã liên kết thương hiệu', 'Привязано к бренду'],
  unlinkedToast: ['연결을 해제했습니다', 'Unlinked from brand', 'Đã hủy liên kết', 'Отвязано от бренда'],
  notLinked: [
    '이 지점은 브랜드에 연결되어 있지 않습니다.',
    'This branch is not linked to a brand.',
    'Chi nhánh này chưa liên kết thương hiệu.',
    'Этот филиал не привязан к бренду.',
  ],
  templateFormHint: [
    '카탈로그에는 가격을 넣지 않습니다. 지점이 가져올 때 직접 입력합니다.',
    'Do not set prices here. Branches enter price when importing.',
    'Không đặt giá ở đây. Chi nhánh nhập giá khi lấy món.',
    'Цены здесь не задаются. Филиал вводит цену при импорте.',
  ],
  templateName: ['메뉴 이름', 'Menu name', 'Tên món', 'Название'],
  templateNamePh: ['예: 황금올리브치킨', 'e.g. Golden Olive Chicken', 'VD: Gà Olive Vàng', 'напр. Курица Golden Olive'],
  templateDesc: ['설명', 'Description', 'Mô tả', 'Описание'],
  templateDescPh: ['재료·특징 등', 'Ingredients, notes…', 'Nguyên liệu, ghi chú…', 'Состав, заметки…'],
  templatePhoto: ['사진', 'Photo', 'Ảnh', 'Фото'],
  addTemplateBtn: ['카탈로그에 추가', 'Add to catalog', 'Thêm vào catalog', 'Добавить в каталог'],
  saveEditBtn: ['수정 저장', 'Save changes', 'Lưu thay đổi', 'Сохранить'],
  cancelEditBtn: ['취소', 'Cancel', 'Hủy', 'Отмена'],
  templateListTitle: ['등록된 메뉴', 'Catalog items', 'Món trong catalog', 'Позиции каталога'],
  templateEmpty: ['아직 등록된 메뉴가 없습니다.', 'No catalog items yet.', 'Chưa có món nào.', 'Пока нет позиций.'],
  templateSaved: ['저장했습니다', 'Saved', 'Đã lưu', 'Сохранено'],
  templateDeleted: ['삭제했습니다', 'Deleted', 'Đã xóa', 'Удалено'],
  deleteConfirm: [
    '이 템플릿을 삭제할까요? 이미 가져온 지점 메뉴는 남습니다.',
    'Delete this template? Branch menus already imported stay as-is.',
    'Xóa mẫu này? Menu chi nhánh đã lấy vẫn giữ nguyên.',
    'Удалить шаблон? Уже импортированные позиции филиалов останутся.',
  ],
  editBtn: ['수정', 'Edit', 'Sửa', 'Изменить'],
  deleteBtn: ['삭제', 'Delete', 'Xóa', 'Удалить'],
  importBtn: ['브랜드 카탈로그에서 가져오기', 'Import from brand catalog', 'Lấy từ catalog thương hiệu', 'Импорт из каталога бренда'],
  importTitle: ['브랜드 카탈로그', 'Brand catalog', 'Catalog thương hiệu', 'Каталог бренда'],
  importEmpty: ['가져올 메뉴가 없습니다.', 'No templates to import.', 'Không có món để lấy.', 'Нет шаблонов для импорта.'],
  importPick: ['가져올 메뉴를 선택하세요', 'Choose a menu item', 'Chọn món để lấy', 'Выберите позицию'],
  importPriceLabel: ['이 지점 판매가', 'Price at this branch', 'Giá tại chi nhánh', 'Цена в этом филиале'],
  importPricePh: ['가격 입력 (필수)', 'Enter price (required)', 'Nhập giá (bắt buộc)', 'Введите цену (обязательно)'],
  importPriceRequired: ['가격을 입력해야 가져올 수 있습니다.', 'Price is required to import.', 'Cần nhập giá để lấy món.', 'Для импорта нужна цена.'],
  importPreviewReadonly: ['이름·사진은 브랜드 카탈로그 기준입니다', 'Name & photo come from the brand catalog', 'Tên & ảnh theo catalog thương hiệu', 'Название и фото из каталога бренда'],
  importConfirmBtn: ['가져오기', 'Import', 'Lấy món', 'Импортировать'],
  importCancelBtn: ['닫기', 'Close', 'Đóng', 'Закрыть'],
  importSuccess: ['메뉴를 가져왔습니다', 'Menu imported', 'Đã lấy món', 'Меню импортировано'],
  errorGeneric: ['처리에 실패했습니다', 'Something went wrong', 'Đã xảy ra lỗi', 'Что-то пошло не так'],

  roleHq: ['본사', 'HQ', 'Trụ sở', 'Головной офис'],
  roleBranch: ['직영점', 'Company-owned', 'Chi nhánh trực thuộc', 'Собственный филиал'],
  roleFranchisee: ['가맹점', 'Franchisee', 'Nhượng quyền', 'Франшиза'],

  nameGenericWarning: [
    '브랜드 이름이 너무 일반적이에요. 고객에게 그대로 노출되니, 실제 브랜드명을 입력해주세요.',
    'This brand name looks too generic. It will be shown to customers as-is — please enter the real brand name.',
    'Tên thương hiệu này quá chung chung. Tên sẽ hiển thị cho khách hàng, hãy nhập tên thương hiệu thật.',
    'Название бренда слишком общее. Оно будет показано клиентам как есть — укажите настоящее название бренда.',
  ],
  nameGenericConfirm: [
    '이 이름으로 계속할까요? 고객 화면에 그대로 노출됩니다.',
    'Continue with this name? It will appear exactly like this to customers.',
    'Tiếp tục với tên này? Tên sẽ hiển thị đúng như vậy cho khách hàng.',
    'Продолжить с этим названием? Клиенты увидят его именно так.',
  ],

  joinSectionTitle: [
    '기존 브랜드에 가맹점으로 합류',
    'Join an existing brand as a franchisee',
    'Tham gia thương hiệu có sẵn với tư cách nhượng quyền',
    'Присоединиться к существующему бренду как франшиза',
  ],
  joinHint: [
    '본사에서 받은 초대코드를 입력하면 가입 신청이 접수돼요. 본사가 승인하면 연결됩니다.',
    'Enter the invite code from HQ to send a join request. It connects once HQ approves it.',
    'Nhập mã mời từ trụ sở để gửi yêu cầu tham gia. Sẽ liên kết sau khi trụ sở phê duyệt.',
    'Введите код приглашения от головного офиса, чтобы отправить заявку. Подключение произойдёт после одобрения.',
  ],
  joinCodePh: ['초대코드 입력', 'Enter invite code', 'Nhập mã mời', 'Введите код приглашения'],
  joinBtn: ['가입 신청', 'Request to join', 'Gửi yêu cầu', 'Отправить заявку'],
  joinSuccessToast: [
    '가입 신청을 보냈어요. 본사 승인을 기다려주세요.',
    'Join request sent. Waiting for HQ approval.',
    'Đã gửi yêu cầu. Đang chờ trụ sở phê duyệt.',
    'Заявка отправлена. Ожидайте одобрения головного офиса.',
  ],
  joinPendingLabel: [
    '가입 신청 중 · 본사 승인 대기',
    'Join request pending · Waiting for HQ',
    'Đang chờ · Chờ trụ sở phê duyệt',
    'Заявка на рассмотрении · Ожидание одобрения',
  ],
  joinPendingBrand: ['신청한 브랜드', 'Requested brand', 'Thương hiệu đã yêu cầu', 'Запрошенный бренд'],
  errorInvalidInviteCode: [
    '초대코드를 확인해주세요.',
    'Please check the invite code.',
    'Vui lòng kiểm tra mã mời.',
    'Проверьте код приглашения.',
  ],
  errorAlreadyLinked: [
    '이미 브랜드에 연결되어 있어요.',
    'This branch is already linked to a brand.',
    'Chi nhánh này đã liên kết thương hiệu.',
    'Этот филиал уже привязан к бренду.',
  ],
  errorRequestPending: [
    '이미 가입 신청이 진행 중이에요.',
    'A join request is already pending.',
    'Yêu cầu tham gia đang chờ xử lý.',
    'Заявка уже находится на рассмотрении.',
  ],

  inviteSectionTitle: ['가맹점 초대', 'Franchisee invites', 'Mời nhượng quyền', 'Приглашение франшиз'],
  inviteHint: [
    '이 코드를 가맹점주에게 전달하세요. 가맹점주가 코드를 입력해 가입을 신청하면, 아래에서 승인할 수 있어요.',
    'Share this code with franchisees. Once they submit a join request with it, approve it below.',
    'Chia sẻ mã này với chủ nhượng quyền. Khi họ gửi yêu cầu bằng mã này, hãy phê duyệt bên dưới.',
    'Поделитесь этим кодом с франчайзи. Когда они отправят заявку с этим кодом, одобрите её ниже.',
  ],
  inviteCodeEmpty: ['발급된 초대코드가 없어요', 'No invite code yet', 'Chưa có mã mời', 'Код приглашения ещё не создан'],
  inviteGenerateBtn: ['초대코드 발급', 'Generate invite code', 'Tạo mã mời', 'Создать код приглашения'],
  inviteRegenerateBtn: ['재발급', 'Regenerate', 'Tạo lại', 'Обновить код'],
  inviteCopyBtn: ['복사', 'Copy', 'Sao chép', 'Копировать'],
  inviteCopiedToast: ['복사했어요', 'Copied', 'Đã sao chép', 'Скопировано'],

  requestsSectionTitle: ['가입 신청', 'Join requests', 'Yêu cầu tham gia', 'Заявки на вступление'],
  requestsEmpty: [
    '아직 가입 신청이 없어요',
    'No join requests yet',
    'Chưa có yêu cầu nào',
    'Заявок пока нет',
  ],
  requestApproveBtn: ['승인', 'Approve', 'Phê duyệt', 'Одобрить'],
  requestRejectBtn: ['거절', 'Reject', 'Từ chối', 'Отклонить'],
  requestApprovedToast: ['가맹점으로 승인했어요', 'Approved as a franchisee', 'Đã phê duyệt làm nhượng quyền', 'Одобрено как франшиза'],
  requestRejectedToast: ['가입 신청을 거절했어요', 'Join request rejected', 'Đã từ chối yêu cầu', 'Заявка отклонена'],
  requestStatusApproved: ['승인됨', 'Approved', 'Đã phê duyệt', 'Одобрено'],
  requestStatusRejected: ['거절됨', 'Rejected', 'Đã từ chối', 'Отклонено'],

  autoPromptTitleNew: [
    '같은 브랜드로 묶을까요?',
    'Link these as one brand?',
    'Liên kết thành một thương hiệu?',
    'Объединить в один бренд?',
  ],
  autoPromptBodyNew: [
    '{name}을(를) 이미 운영 중이시네요. 브랜드 이름을 정하면 두 매장이 같은 브랜드로 연결돼요. 나중에 관리 화면에서 언제든 바꿀 수 있어요.',
    'You already run {name}. Give it a brand name and both stores will be linked. You can change this anytime from the manage screen.',
    'Bạn đang vận hành {name}. Đặt tên thương hiệu để liên kết cả hai cửa hàng. Có thể đổi bất cứ lúc nào trong màn hình quản lý.',
    'Вы уже управляете {name}. Задайте название бренда, чтобы связать оба магазина. Изменить можно в любой момент в разделе управления.',
  ],
  autoPromptTitleExisting: [
    '{brand} 브랜드에 새 매장도 연결할까요?',
    'Link the new store to {brand} too?',
    'Liên kết cửa hàng mới với thương hiệu {brand}?',
    'Привязать новый магазин к бренду {brand}?',
  ],
  autoPromptBodyExisting: [
    '{name}이(가) 이미 {brand} 브랜드로 등록되어 있어요. 새로 등록한 매장도 같은 브랜드로 묶을 수 있어요.',
    '{name} is already linked to the {brand} brand. You can link your new store to the same brand.',
    '{name} đã liên kết với thương hiệu {brand}. Bạn có thể liên kết cửa hàng mới với cùng thương hiệu này.',
    '{name} уже привязан к бренду {brand}. Новый магазин можно привязать к тому же бренду.',
  ],
  autoPromptNamePh: ['브랜드 이름', 'Brand name', 'Tên thương hiệu', 'Название бренда'],
  autoPromptLinkBtn: ['브랜드로 묶기', 'Link as one brand', 'Liên kết thương hiệu', 'Объединить в бренд'],
  autoPromptSkipBtn: ['나중에', 'Later', 'Để sau', 'Позже'],
  autoPromptSuccessToast: [
    '브랜드로 연결했어요',
    'Linked as one brand',
    'Đã liên kết thương hiệu',
    'Объединено в бренд',
  ],
};

function buildLang(langIndex) {
  return {
    brandCatalog: pick(brandCatalog, langIndex),
  };
}

export const phaseBrandCatalogKo = buildLang(0);
export const phaseBrandCatalogEn = buildLang(1);
export const phaseBrandCatalogVi = buildLang(2);
export const phaseBrandCatalogRu = buildLang(3);
